<template>
  <div class="teams-create-view container py-4">
    <TeamCreate />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useTeamsStore } from '@/stores/teams'
import TeamCreate from '@/components/teams/TeamCreate.vue'

const teamsStore = useTeamsStore()



</script>
